<template>
  <div class="content">
    <div class="search-area mb15">
      <div class="w100f t-left mb15"><b>产品信息</b></div>
      <el-row :gutter="20">
        <el-col :span="7"
          ><div class="search-area-div-text">产品名称：{{ productInformationList.goodsName }}</div>
        </el-col>
        <el-col :span="5"
          ><div class="search-area-div-text">产品编码：{{ productInformationList.goodsCode }}</div>
        </el-col>
        <el-col :span="5"
          ><div class="search-area-div-text">规格：{{ productInformationList.goodsSpec }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7"
          ><div class="search-area-div-text">单位：{{ productInformationList.unitStyle }}</div>
        </el-col>
        <el-col :span="5"
          ><div class="search-area-div-text">生产企业：{{ productInformationList.producer }}</div>
        </el-col>
        <el-col :span="5"
          ><div class="search-area-div-text">装箱量：{{ productInformationList.bigUnitQty }}</div>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <div class="w100f t-left mb15"><b>产品指导价</b></div>
      <div class="search-area" style="margin-bottom: 30px; border-bottom: 1px solid #ddd;border-radius: unset;padding-left: 0;padding-right: 0px;margin-right: 15px;">
        <el-row :gutter="24">
          <el-col :span="7"
            ><div class="search-area-div">医院名称：</div>
            <el-input v-model="page.medName" class="ipt-sty" placeholder="请输入医院名称"></el-input
          ></el-col> 
          <el-col :span="8">
            <div>
              <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
              <el-button size="medium" type="danger" @click="empty">清空</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add()">新增医院指导价</el-button>
      <el-button size="medium" type="info" @click="openSubmitAlert">批量导入价格</el-button>
      <!-- <el-button plain size="medium">历史数据</el-button> -->
    </div>
    <div class="back-color-fff" style="padding: 16px">
      <el-table :data="tableData" style="width: 100%" row-key="guid" @selection-change="handleSelectionChange" border>
        <!-- <el-table-column  width="60" header-align="center" align="center"></el-table-column> -->
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="medName" label="医院名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="price" label="指导价" header-align="center" align="center">
          <template slot-scope="scope"> 
            <span v-show="scope.row.priceType == '1'">{{ scope.row.price | numDigit | numFmt }}</span>
            <span v-show="scope.row.priceType == '2'">{{ scope.row.price | numDigit | numFmt }}~{{ scope.row.maxPrice | numDigit | numFmt }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" header-align="center" sortable align="center">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="edit(scope.row)">编辑指导价 | </a>
            <a class="txt-color" @click="del(scope.row)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px" :close-on-click-modal="false">
      <el-form :model="ruleForm"  ref="ruleForm" label-width="128px" :label-position="right" class="demo-ruleForm">
        <el-form-item label="*医院:" prop="price">
          <el-select v-model="ruleForm.medGuid" :disabled="isEdit" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in optionsMedical" :key="item.guid" :label="item.medName" :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="*价格类型:" style="width:60%">
          <el-radio v-model="ruleForm.priceType" label="1">固定价</el-radio>
          <el-radio v-model="ruleForm.priceType" label="2">区间价</el-radio>
        </el-form-item>
        <el-form-item label="*指导价:" prop="price" v-show="ruleForm.priceType == 1">
          <el-input
            v-model="ruleForm.price"
            @blur="ruleForm.price = Number($event.target.value)"
            oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)"
            autocomplete="off"
            placeholder="请填写指导价"
            class="w100f"
          ></el-input>
        </el-form-item>
        <el-form-item label="*指导价:" prop="price" v-show="ruleForm.priceType == 2">
          <el-input v-model="ruleForm.price" @blur="ruleForm.price = Number($event.target.value)" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" autocomplete="off" style="width:175px" placeholder="最低价"></el-input>
          <span style="margin:0 10px">-</span>
          <el-input v-model="ruleForm.maxPrice" @blur="ruleForm.maxPrice = Number($event.target.value)" oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" autocomplete="off" style="width:175px" placeholder="最高价"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button v-if="!isEdit" size="medium" type="info" @click="addDataForm">确定</el-button>
        <el-button v-else size="medium" type="info" @click="upDateForm">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量导入价格" :visible.sync="dialogFormVisibleII" width="700px" height="900px">
      <el-steps :active="active" align-center >
        <el-step title="上传文件"></el-step>
        <el-step title="导入完成"></el-step>
      </el-steps>
      <div v-if="active == 1" >
        <h3>导入成功，请核对！</h3>
        <p>{{msg}}</p>
        <span v-if="showBtn" style="text-decoration: underline;cursor: pointer;" @click="downLoadErrorExcel">下载导入失败数据</span>
      </div>
      <div class="search-area " style="margin-top:-15px;margin-left:20px;">
        <div class="import-sty">
          <div v-if="active == 0">
            <div class="ml71">
              <div class="mt15 mt50">
                下载模板：<el-button plain size="medium" @click="downLoadExcel">下载文件模板</el-button>
              </div>
               <div slot="tip" class="el-upload__tip" style="text-indent:70px;margin-bottom:50px;color:#888;line-height: 20px;">
                <div>注意事项：</div>
                <div>1、请先下载Excel模版，严格按照模板内容填入数据，再上传文件到系统;</div>
                <div>2、若导入医院已存在，那么原价格将覆盖；</div>
              </div>
              <div class="mt15 mt15 h120">
                <p class="fl">导入文件：</p>
                <el-upload
                  class="upload-demo fl"
                  action="#"
                  :before-upload="beforeUpload"
                  multiple
                  :limit="1"
                  accept=".xlsx,.xsl,.xls,.xlsm"
                  :auto-upload="false"
                  :on-change="changeFile"
                  :on-exceed="handleExceed"
                  ref="upload"
                >
                  <el-button size="medium" type="info" v-loading.fullscreen.lock="fullscreenLoading"
                    >点击上传文件</el-button
                  >
                  <div slot="tip" class="el-upload__tip" style="color:#888;line-height: 20px;">
                    注意事项：<br>
                    1、仅支持excel文件，大小<=2M；<br>
                    2、使用 Office 2010 及以上版本，避免出现乱码；<br>
                  </div>
                </el-upload>
            
              </div>
              <div slot="footer" class="dialog-footer" style="width: 60%;text-align: right;">
                <el-button plain size="medium" @click="closeUpload">取消</el-button>
                <el-button  size="medium" type="info" @click="sureLoad">确定</el-button>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="进度提示"
      :visible.sync="dialogVisible"
      width="30%">
      <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
    </el-dialog> 
  </div>
</template>

<script>
export default {
  data() {
    let price = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('指导价不能为空'));
      } else {
        const reg = /^\d+(?:\.\d{1,2})?$/;
        console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入必须大于0且最多有两位小数的指导价'));
        }
      }
    };
    return {
      productInformationList: '',
      tableData: [],
      provinces: [],
      ruleForm: {
        priceType: '1',
        price: 0,
        maxPrice: '',
        medGuid: '',
      },
      textTitle: '新增指导价',
      dialogFormVisible: false,
      right: '',
      optionsMedical: [],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        goodsGuid: '',
        tenantGuid: '',
        medName: '',
      },
      isEdit: false,
      active: 0,
      id: '',
      dialogFormVisibleII: false,
      fullscreenLoading:false,
      file:"",
      msg:"",
      showBtn:false,
      progressGuid:'',
      percentage:0,
      dialogVisible:false,
    };
  },
  created() {
    // 列表
    this.getGoodDetail();
    this.getData(true);
    this.getMedical();
  },
  methods: {
    empty() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        goodsGuid: '',
        tenantGuid: '',
        medName: '',
      
      };
    },
    getMedical() {
      var self = this;
      let query = {
        tenantGuid: self.$store.state.guid,
        pageIndex: 1,
        pageSize: -1,
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/med/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.optionsMedical = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.tableData = [];
      self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.page.goodsGuid = self.$route.query.guid;
      self.api.postJson(`/${serverConfig.msProductService}/goods/data/get-goods-med-price`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = [];
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getGoodDetail() {
      let self = this;
      self.productInformationList = '';
      self.api
        .get(
          `/${serverConfig.msProductService}/goods/data/get-current-guidanceprice?goodsGuid=` +
            self.$router.history.current.query.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.productInformationList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    handleSelectionChange(val) {
      let self = this;
      self.provinces = [];
      val.forEach(function (i) {
        let item = {
          province: i.province,
          venue: i.venue,
        };
        self.provinces.push(item);
        console.log(self.provinces);
      });
    },
    add() {
      let self = this;
      self.dialogFormVisible = true;
      self.isEdit = false;
      self.textTitle = '新增指导价',
      self.ruleForm.priceType = '1';
      self.ruleForm.price = 0;
      self.ruleForm.maxPrice = '';
      self.ruleForm.medGuid = '';
      self.ruleForm.medName = '';
    },
    addDataForm() {
      var self = this;
      if (this.ruleForm.price == '') {
        this.$message.error('请填写指导价');
        return;
      }
      if (this.ruleForm.price < 0) {
        this.$message.error('请填写正确指导价');
        return;
      }
      if (this.ruleForm.priceType == '2' && Number(this.ruleForm.maxPrice) <= Number(this.ruleForm.price)) {
        this.$message.error('最高价必须大于最低价!');
        return;
      }
      if (this.ruleForm.medGuid == '') {
        this.$message.error('请选择医院');
        return;
      }
      let medObj = this.optionsMedical.filter((item) => item.guid == this.ruleForm.medGuid);
      let medName = medObj[0].medName;
      let params = {
        medName: medName,
        medGuid: this.ruleForm.medGuid,
        priceType: this.ruleForm.priceType,
        price: +this.ruleForm.price,
        maxPrice: +this.ruleForm.maxPrice,
        tenantGuid: this.$store.getters.getTenantGuid,
        goodsGuid: this.$route.query.guid,
      };
      self.api.postJson(`/${serverConfig.msProductService}/goods/data/add-goods-med-price`, params).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('新增成功');
          self.dialogFormVisible = false;
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    edit(row) {
      let self = this;
      self.dialogFormVisible = true;
      self.isEdit = true;
      self.ruleForm.priceType = row.priceType;
      self.ruleForm.price = row.price;
      self.ruleForm.maxPrice = row.maxPrice;
      self.ruleForm.medGuid = row.medGuid;
      self.ruleForm.medName = row.medName;
      self.id = row.guid;
      self.textTitle = '编辑指导价';
    },
    upDateForm() {
      var self = this;
      if (this.ruleForm.price == '') {
        this.$message.error('请填写指导价');
        return;
      }
      if (this.ruleForm.price < 0) {
        this.$message.error('请填写正确指导价');
        return;
      }
      if (this.ruleForm.priceType == '2' && Number(this.ruleForm.maxPrice) <= Number(this.ruleForm.price)) {
        this.$message.error('最高价必须大于最低价!');
        return;
      }
      let params = {
        medName: this.ruleForm.medName,
        medGuid: this.ruleForm.medGuid,
        priceType: this.ruleForm.priceType,
        price: +this.ruleForm.price,
        maxPrice: +this.ruleForm.maxPrice,
        tenantGuid: this.$store.getters.getTenantGuid,
        goodsGuid: this.$route.query.guid,
        guid: this.id,
      };
      self.api.postJson(`/${serverConfig.msProductService}/goods/data/add-goods-med-price`, params).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('修改成功');
          self.dialogFormVisible = false;
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    del(row) {
      var self = this;
      let params = [row.guid];
      self.api.postJson(`/${serverConfig.msProductService}/goods/data/remove-goods-med-price`, params).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('删除成功');
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    openSubmitAlert() {
      this.dialogFormVisibleII = true; 
      this.active = 0;
      setTimeout(()=>{
        this.$refs.upload.clearFiles();
      },200);
    },
    downLoadExcel(){
      window.open('/hospital_price.xlsx');
    },
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split('.');
      if (arr[1] !== 'xls' && arr[1] !== 'xlsx'&& arr[1] !== 'xlsm') {
        this.$message.error('上传文件只能是 excel/xls 格式!');
        return false;
      }
      return arr;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    changeFile(file){
      this.file = file;
    },
    generateUUID() {
        var d = new Date().getTime();
        if (window.performance && typeof window.performance.now === "function") {
            d += performance.now(); //use high-precision timer if available
        }
        var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    },
    sureLoad() {
      let self = this;
      self.percentage = 0;
      self.progressGuid = self.generateUUID();
      let timer = setInterval(self.getImportProgress, 1000);
      self.dialogVisible = true;
      let file = this.file;
      let formData = new FormData();
      let url = '';
      // self.fullscreenLoading = true;
      formData.append('file', file.raw); //传文件
      self.api.postFile(`/${serverConfig.msProductService}/import-data/goods-med-price?tenantGuid=`+self.$store.state.guid+'&guid='+self.$route.query.guid+'&progressGuid='+self.progressGuid, formData).then(function(res) {
         // self.fullscreenLoading = false;
         clearInterval(timer);
         self.dialogVisible = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.active = 1;
          self.msg = res.data.data;
          self.getData(true);
          self.checkDownloadBtn(res.data.data)
        } else {
          self.$message({
            type: 'warning',
            message: res.data.msg,
          });
          return false;
        }
      });
    },
    getImportProgress() {
      let self = this; 
      self.api.postJson(`/${serverConfig.msCommonAdminCloudService}/excel/import/get-import-progress?guid=`+self.progressGuid).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.percentage = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    closeUpload(){
      this.dialogFormVisibleII = false;
      this.$refs.upload.clearFiles();
      this.active = 0;
    },
    checkDownloadBtn(msg){
      if(msg.indexOf('失败 0 条')>-1){
        this.showBtn = false;
      }else{
         this.showBtn = true;
      }
    },
    downLoadErrorExcel() {
      let self = this;
      let query = {
        tenantGuid: this.$store.getters.getTenantGuid,
      }
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msProductService}/goods/data/export-goods-med-price-error-report`,query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    reportJx(colNames,datas,sheetName,fileNam,dataComments){
        let self = this; 
          self.api.postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`,{'colNames':colNames,'datas':datas,'sheetName':sheetName,'fileNam':fileNam})
          .then(res => {  
             let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
              let fileName = fileNam;
              let objectUrl = URL.createObjectURL(blob);
              const link = document.createElement('a')
              link.download = fileName;
              link.href = objectUrl;
              link.click();
              self.fullscreenLoading = false;
          }); 
    },  
  },
};
</script>
